import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const TrexNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="trex" />;
};
